import { getCookie } from './cookies'
const COOKIE_WEBVIEW = 'webview'
export default (cookie = COOKIE_WEBVIEW) => {
    return !!getCookie(cookie)
}